"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewGroup extends new_item_1.default {
    constructor(newGroup) {
        super();
        this.dataTypes = newGroup.dataTypes;
        if (!newGroup.name) {
            throw Error("name required");
        }
        this.name = newGroup.name;
        this.widgetBoardId = newGroup.widgetBoardId;
        this.groupTypeId = newGroup.groupTypeId;
        this.assetIds = newGroup.assetIds;
        this.parentIds = newGroup.parentIds;
        this._permission = newGroup._permission;
    }
}
exports.default = NewGroup;
//# sourceMappingURL=new-group.js.map